const localeValue = {
  ko: {
    optionalInputDescription: "\uC120\uD0DD \uC785\uB825\uC774\uC5D0\uC694.",
    itemCount: (count) => `\uCD1D ${count}\uC77C \uC120\uD0DD`,
    monthCount: (count) => `\uCD1D ${count}\uAC1C\uC6D4 \uC120\uD0DD`
  },
  en: {
    optionalInputDescription: "Optional Input",
    itemCount: (count) => `${count}days selected`,
    monthCount: (count) => `${count}months selected`
  }
};

export { localeValue };
//# sourceMappingURL=localeValues.mjs.map
